import { Component, OnDestroy } from '@angular/core';
import { BroadcastService, BroadcastEventModel } from '@cv-invision/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export const IDLE_USER_OPEN_MODAL = 'idleUserOpenModal';
export const IDLE_USER_STILL_THERE = 'idleUserStillThere';

@Component({
	selector: 'cv-confirmation-inactivity',
	templateUrl: './confirmation-inactivity.component.html',
	styleUrls: ['./confirmation-inactivity.component.scss']
})
export class ConfirmationInactivityComponent implements OnDestroy {
	isOpen: boolean;
	private atComponentDestroy: Subject<any> = new Subject<any>();
	constructor(private broadcastService: BroadcastService) {
		this.isOpen = false;
		this.registerConfirmationListener();
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}

	/**
	 * Closes the modal.
	 * @param $event: any
	 */

	stillThere(): void {
		this.isOpen = false;
		this.broadcastService.broadcast({
			name: IDLE_USER_STILL_THERE,
			event: true
		});
	}

	/**
	 * Register Listener to Show/Hide the modal
	 */
	private registerConfirmationListener(): void {
		this.broadcastService
			.onEvent(IDLE_USER_OPEN_MODAL)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((broadcast: BroadcastEventModel) => {
				this.isOpen = broadcast.event.isOpen;
			});
	}
}
